/**
 * Анкета, краткое описание
 */
import { Identity } from '@n3/ng-api-common';
import { EntityState } from '@n3/ng-api-common';
import { BaseModel } from '@n3/ng-api-base-kit';

export class QuestionaryShort extends BaseModel {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public identity: Identity; /**/
    public entity_state: EntityState; /**/
    public name: string; /*Название*/
    public description: string; /*Описание*/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super();

        this.identity = new Identity(json.identity);
        this.entity_state = new EntityState(json.entity_state);
        this.name = json.name || null;
        this.description = json.description || null;
        this._isEmpty = this.isEmpty(this);
    }
}
